import { Box, ThemeProvider, Fade, Container } from '@mui/material';
import FilesTable from '../components/FilesTable';
import HeaderBar, { CurrentPages } from '../header-bar/HeaderBar';
import PageHeader from '../components/PageHeader';
import GradientBackground from '../resources/components/GradientBackground';
import theme from '../resources/NodeTheme';
import { useTranslation } from 'react-i18next';

const FilesPage = () => {
  const { t } = useTranslation();
  
  return (
    <ThemeProvider theme={theme}>
      <GradientBackground sx={{ minHeight: '100vh' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
          <HeaderBar
            currentPage={CurrentPages.Files}
            setCurrentPage={() => {}}
          />
          <Fade in={true} timeout={500}>
            <Box sx={{ 
              flex: 1,
            }}>
              <Box sx={{
                paddingTop: { xs: 2, sm: 3 },
                paddingLeft: { xs: 2, sm: 3 },
                paddingRight: { xs: 2, sm: 3 },
                paddingBottom: 0,
              }}>
                <PageHeader title={t('Files')} />
              </Box>
              <FilesTable />
            </Box>
          </Fade>
        </Box>
      </GradientBackground>
    </ThemeProvider>
  );
};

export default FilesPage; 